
import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Fitness', path: '/fitness' },
    { name: 'Recipes', path: '/recipes' },
    { name: 'Cowork', path: '/cowork' },
    { name: 'Learn', path: '/learn' },
    { name: 'Travel', path: '/travel' },
    { name: 'Events', path: '/events' },
    { name: 'Marketplace', path: '/marketplace' },
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white/95 backdrop-blur-sm border-b border-zinc-200' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20 lg:h-24">
            <button
              onClick={() => scrollToSection('hero')}
              className="text-xl lg:text-2xl font-bold tracking-tight cursor-pointer"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              STUDIO
            </button>

            <div className="hidden lg:flex items-center gap-12">
              <button
                onClick={() => scrollToSection('work')}
                className="text-sm uppercase tracking-wider text-zinc-600 hover:text-zinc-900 transition-colors cursor-pointer"
              >
                Work
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-sm uppercase tracking-wider text-zinc-600 hover:text-zinc-900 transition-colors cursor-pointer"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="text-sm uppercase tracking-wider text-zinc-600 hover:text-zinc-900 transition-colors cursor-pointer"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-sm uppercase tracking-wider text-zinc-600 hover:text-zinc-900 transition-colors cursor-pointer"
              >
                Contact
              </button>
            </div>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden text-zinc-900 cursor-pointer"
            >
              <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="fixed inset-0 bg-white z-40 lg:hidden pt-24 px-6"
        >
          <div className="flex flex-col gap-8">
            <button
              onClick={() => scrollToSection('work')}
              className="text-3xl font-light text-zinc-900 text-left cursor-pointer"
            >
              Work
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-3xl font-light text-zinc-900 text-left cursor-pointer"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-3xl font-light text-zinc-900 text-left cursor-pointer"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-3xl font-light text-zinc-900 text-left cursor-pointer"
            >
              Contact
            </button>
          </div>
        </motion.div>
      )}
    </>
  );
}
